import { useCallback, useEffect, useRef } from "react";
import { useDispatch } from "react-redux";
import { useLocation } from "react-router-dom";
import { actions } from "reducers/preliquidation";

const useRoutes = () => {
  const lastPath = useRef("");
  const { pathname } = useLocation();
  const dispatch = useDispatch();

  const resetPreliquidationFilters = useCallback(() => {
    dispatch(actions.resetFilters());
  }, [dispatch]);

  useEffect(() => {
    if (
      lastPath.current.includes("presettlements") &&
      !pathname.includes("presettlements")
    ) {
      resetPreliquidationFilters();
    }

    lastPath.current = pathname;
  }, [dispatch, pathname, resetPreliquidationFilters]);
};

export default useRoutes;
